import React, { Component } from "react";
export default class Footer extends Component {
    render() {
        let siteDetails = sessionStorage.getItem("siteDetails");
        let siteDetailsArray = siteDetails ? JSON.parse(siteDetails) : [];
        return (
            <div><div className="footer">
                {console.log("sitedetailaaaaaaaaaaaaaaaaaaaaa",siteDetailsArray)}
                <footer>
                    <div className="container">
                        <div className="footer-copy footer-subsec">
                        <p>© Copyright {new Date().getFullYear()}. MaeveLifeStyle. Scenting Your World with Luxury.</p>
                        </div>
                    </div>
                </footer>
            </div></div>
        )
    }
}
